import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "./styles.module.css";
import { ButtonProps } from "@mui/material";

export const ExportSchemaBtn = ({ ...props }: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"outlined"}
      className={styles["export-schema-btn"]}
      {...props}
    >
      {t("schemas.export_schema_btn")}
    </AppButton>
  );
};
